import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';

const ComplainList = () => import('@/modules/complain/pages/ComplainList.vue');
const ComplainForm = () => import('@/modules/complain/pages/ComplainForm.vue');

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'complain',
                path: '/complain',
                component: ComplainList,
                meta: {
                    auth: true,
                    permission: Permissions.values.complainView,
                }
            },
            {
                name: 'complainNew',
                path: '/complain/new',
                component: ComplainForm,
                meta: {
                    auth: true,
                    permission: Permissions.values.complainCreate,
                }
            },
            {
                name: 'complainView',
                path: '/complain/:id',
                component: ComplainForm,
                meta: {
                    auth: true,
                    permission: Permissions.values.complainView,
                },
                props: true,
            },
        ],
    },
];
